"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$grey, _theme$palette2, _theme$palette2$grey, _theme$palette3, _theme$palette4, _theme$palette4$prima;
  return {
    productOverview: {
      "&::after": {
        clear: "both",
        content: "''",
        display: "block"
      }
    },
    wrapper: _defineProperty({
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(1)
    }, theme.breakpoints.up("md"), {
      marginBottom: theme.spacing(2)
    }),
    column: _defineProperty({
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(4)
    }, theme.breakpoints.up("md"), {
      float: "left",
      position: "sticky",
      top: 0,
      width: "23.64457831325301%"
    }),
    hasLeftColumn: _defineProperty({}, theme.breakpoints.up("md"), {
      margin: "0 0 0 25.45180722891566%"
    }),
    filterWrapper: _defineProperty({
      "& .mco-filter-item__accordion": {
        borderBottomColor: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$grey = _theme$palette.grey) === null || _theme$palette$grey === void 0 ? void 0 : _theme$palette$grey[100],
        marginLeft: "".concat(theme.spacing(-2), "px !important"),
        marginRight: "".concat(theme.spacing(-2), "px !important"),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        "& .mco-filter-item__option-wrapper": {
          maxHeight: "100%"
        },
        "&.Mui-expanded": {
          background: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$grey = _theme$palette2.grey) === null || _theme$palette2$grey === void 0 ? void 0 : _theme$palette2$grey[50]
        },
        "& .MuiAccordionSummary-content": {
          marginBottom: 0,
          marginTop: 0
        }
      },
      "& .mco-filter-item__accordion-label": {
        minHeight: "74px !important"
      },
      "& .mco-filter-item__accordion-skeleton": {
        "& span": {
          height: "74px !important"
        }
      },
      "& .mco-filter-item__label": {
        "&--selected": {
          color: "".concat((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.getContrastText((_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$prima = _theme$palette4.primary) === null || _theme$palette4$prima === void 0 ? void 0 : _theme$palette4$prima.main), " !important")
        }
      }
    }, theme.breakpoints.up("md"), {
      alignItems: "center",
      display: "flex",
      gap: theme.spacing(2),
      justifyContent: "space-between"
    }),
    filterWrapperHasFilter: {
      alignItems: "flex-start"
    },
    preloader: {
      marginTop: 45
    },
    paper: {
      height: "100%",
      maxWidth: "100%",
      overflowX: "hidden",
      width: "100%",
      zIndex: theme.zIndex.modal + 10,
      "& .mco-shop-product-overview__filter": {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: theme.spacing(5, 2, 0)
      },
      "& .mco-shop-product-overview__column": {
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        padding: theme.spacing(5, 2, 2)
      },
      "& .mco-shop-product-overview__search": {
        marginTop: "auto"
      }
    }
  };
});
var _default = styles;
exports.default = _default;